import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { useEffect } from "react";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { http } from "@/lib/api";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Scholarships from "@/pages/Scholarships";
import PaperAssistant from "@/pages/PaperAssistant";
import Journals from "@/pages/Journals";
import Thesis from "@/pages/Thesis";
import ThesisDraft from "@/pages/ThesisDraft";
import Profile from "@/pages/Profile";
import Donation from "@/pages/Donation";
import Admin from "@/pages/Admin";
import Haki from "@/pages/Haki";
import HakiDetail from "@/pages/HakiDetail";
import AppShell from "@/components/AppShell";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-500">Memuat…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <AppShell>{children}</AppShell>;
}

function AdminOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-500">Memuat…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (!user.is_admin) return <Navigate to="/dashboard" replace />;
  return <AppShell>{children}</AppShell>;
}

function VisitTracker() {
  const location = useLocation();
  useEffect(() => {
    http.post("/track/visit", { path: location.pathname }).catch(() => {});
  }, [location.pathname]);
  return null;
}

function Router() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <>
      <VisitTracker />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
        <Route path="/beasiswa" element={<Protected><Scholarships /></Protected>} />
        <Route path="/paper" element={<Protected><PaperAssistant /></Protected>} />
        <Route path="/direktori-jurnal" element={<Protected><Journals /></Protected>} />
        <Route path="/tugas-akhir" element={<Protected><Thesis /></Protected>} />
        <Route path="/tugas-akhir/draft/:id" element={<Protected><ThesisDraft /></Protected>} />
        <Route path="/haki" element={<Protected><Haki /></Protected>} />
        <Route path="/haki/:id" element={<Protected><HakiDetail /></Protected>} />
        <Route path="/donasi" element={<Protected><Donation /></Protected>} />
        <Route path="/admin" element={<AdminOnly><Admin /></AdminOnly>} />
        <Route path="/profil" element={<Protected><Profile /></Protected>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Router />
        <Toaster richColors position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}
